import React from 'react';

function NotFound() {
  return (
    <div className='notfound-container'>
    <section id="notfound">
    <h1>Page Not Found</h1>
      <p>The page you are looking for does not exist.</p>
    </section>
    </div>
  );
}

export default NotFound;